/**
 * Use to match KeyboardEvent.code
 * @source https://developer.mozilla.org/en-US/docs/Web/API/UI_Events/Keyboard_event_code_values
 * @see KeyboardKey
 */
export enum KeyboardCode {
    Enter = 'Enter',
    EnterNumpad = 'NumpadEnter',
    Escape = 'Escape',
    ArrowUp = 'ArrowUp',
    ArrowDown = 'ArrowDown',
    ArrowLeft = 'ArrowLeft',
    ArrowRight = 'ArrowRight',
    Backspace = 'Backspace',
    Space = 'Space',
    Delete = 'Delete',
    Tab = 'Tab',
    ShiftLeft = 'ShiftLeft',
    ShiftRight = 'ShiftRight',
    ControlLeft = 'ControlLeft',
    ControlRight = 'ControlRight',
    AltLeft = 'AltLeft',
    AltRight = 'AltRight',
    Pause = 'Pause',
    CapsLock = 'CapsLock',
    PageUp = 'PageUp',
    PageDown = 'PageDown',
    End = 'End',
    Home = 'Home',
    Insert = 'Insert',
    MetaLeft = 'MetaLeft', // windows key, ⌘, Command
    MetaRight = 'MetaRight', // windows key, ⌘, Command
    ContextMenu = 'ContextMenu', // windows/os on right side
    F1 = 'F1',
    F2 = 'F2',
    F3 = 'F3',
    F4 = 'F4',
    F5 = 'F5',
    F6 = 'F6',
    F7 = 'F7',
    F8 = 'F8',
    F9 = 'F9',
    F10 = 'F10',
    F11 = 'F11',
    F12 = 'F12',
    NumLock = 'NumLock',
    ScrollLock = 'ScrollLock',
    OpenParentheses = 'Digit9',
    CloseParentheses = 'Digit0',
    AltGraph = 'AltGraph',
}
